import "#legacy/admin/assessment_builder/_generated_templates.js";
import "#legacy/admin/components/wysiwyg.js";
import "#legacy/admin/assessment_builder/views/base.js";
import "#legacy/admin/assessment_builder/views/mixins/thumbnail_editor.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Views ??= {};

AssessmentBuilder.Views.AssessmentForm = class AssessmentForm extends (
  AssessmentBuilder.Views.Mixins.ThumbnailEditor(AssessmentBuilder.Views.Base)
) {
  constructor() {
    super(...arguments);
    this.render = this.render.bind(this);
  }

  render() {
    this.$el.html(
      this.template(
        this.selectTemplateContext(this.model.attributes, {
          contentPositionItems: "content_position",
          scoringItems: "scoring",
        }),
      ),
    );
    super.render(...arguments);
    Sparkle.Components.Wysiwyg.attach(this.$("textarea[name=completion_page_content]"), { toolset: "extended" });

    return this;
  }
};
AssessmentBuilder.Views.AssessmentForm.prototype.tagName = "assessment-form";
AssessmentBuilder.Views.AssessmentForm.prototype.className = "assessment-form --view-assessment";
AssessmentBuilder.Views.AssessmentForm.prototype.template = _.template(AssessmentBuilder.Templates.Assessment.form);
AssessmentBuilder.Views.AssessmentForm.prototype.editorTriggerElementSelector =
  '[data-assessment-builder-behaviour~="assessment-thumbnail-editor"]';
AssessmentBuilder.Views.AssessmentForm.prototype.events = { "change :input, sp-select": "handleAttributeChange" };
